import { useEffect } from 'react';
import { getThankYou } from '@features/dcb-flow';

export const useGetThankYou = (
  sessionId: string | null | undefined,
  isShownMsisdn: boolean,
  aggregator: string | null = null,
  enabled: boolean = true
): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    getThankYou(sessionId || null, isShownMsisdn, aggregator);
  }, [sessionId, isShownMsisdn, aggregator, enabled]);
};
